import axios from 'axios'
import {
  ContractModel,
  CECOModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
  TableResumen,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getContract(dto: ContractModel, page: number) {
  return axios.post<ResponseObjectPaginated<ContractModel[]>>(
    `${BASEURL}/receptionistService/getAll/${page}`,
    dto,
  )
}

export function getContractById(dto: any | undefined) {
  return axios.get<ResponseObject<ContractModel>>(
    `${BASEURL}/receptionistService/getInformationById?receptionistServiceId=${dto}`,
  )
}

export function createContract(dto: ContractModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/receptionistService/createReceptionistService`, dto)
}

export function deleteContract(dto: any) {
  return axios.delete<ResponseCRUD>(
    `${BASEURL}/receptionistService/deleteReceptionistService?id=${dto}`,
  )
}

export function updateContract(dto: ContractModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/receptionistService/updateReceptionistService`, dto)
}

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplateContract() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/receptionistService/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveContract(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(
    `${BASEURL}/receptionistService/bulkLoad`,
    dto,
  )
}

// FIN ---- SERVICIOS MASIVE

// CECO SERVICE

export function getCECO(dto: CECOModel, page: number, size: number = 10) {
  return axios.post<ResponseObjectPaginated<CECOModel[]>>(
    `${BASEURL}/CostCenter/getAll/${page}`,
    dto,
    {params: {size}},
  )
}

export function getCECOById(id: any | undefined) {
  return axios.get<ResponseObject<CECOModel>>(
    `${BASEURL}/CostCenter/getInformationById?CostCenterId=${id}`,
  )
}

export function createCECO(dto: CECOModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/CostCenter/createCostCenter`, dto)
}

export function deleteCECO(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/CostCenter/deleteCostCenter?id=${dto}`)
}

export function updateCECO(dto: CECOModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/CostCenter/updateCostCenter`, dto)
}
